export const Main = r => require.ensure([], () => r(require('../../Core/components/Main')), 'Records-bundle')

export const ListUsers = r => require.ensure([], () => r(require('../components/Users/ListUsers')), 'Users-bundle')
export const EditAddUser = r => require.ensure([], () => r(require('../components/Users/EditAddUser')), 'Users-bundle')

export const ListPlan = r => require.ensure([], () => r(require('../components/Plan/ListPlan')), 'Plan-bundle')
export const FormPlan = r => require.ensure([], () => r(require('../components/Plan/forms/FormPlan')), 'Plan-bundle')
export const FormEditPlan = r => require.ensure([], () => r(require('../components/Plan/forms/FormEditPlan')), 'Plan-bundle')

export const ListMarketplaces = r => require.ensure([], () => r(require('../components/Marketplaces/ListMarketplaces')), 'Marketplaces-bundle')
export const EditAddMarketplace = r => require.ensure([], () => r(require('../components/Marketplaces/EditAddMarketplace')), 'Marketplaces-bundle')


export const ListEstaComercial = r => require.ensure([], () => r(require('../components/EstabelecimentoComercial/ListEstaComercial')), 'EstaComercial-bundle')
export const EditAddEstaComercial = r => require.ensure([], () => r(require('../components/EstabelecimentoComercial/EditAddEstaComercial')), 'EstaComercial-bundle')

export const ListModelEquipamento = r => require.ensure([], () => r(require('../components/ModeloEquipamento/ListModelEquipamento')), 'ModelEquipment-bundle')
export const EditAddModelEquipamento = r => require.ensure([], () => r(require('../components/ModeloEquipamento/EditAddModelEquipamento')), 'ModelEquipment-bundle')

export const ListEquipamentos = r => require.ensure([], () => r(require('../components/Equipamentos/ListEquipamentos')), 'Equipamento-bundle')
export const EditAddEquipamento = r => require.ensure([], () => r(require('../components/Equipamentos/EditAddEquipamento')), 'Equipamento-bundle')

export const ListTerminais = r => require.ensure([], () => r(require('../components/Terminais/ListTerminais')), 'Terminal-bundle')
export const EditAddTerminal = r => require.ensure([], () => r(require('../components/Terminais/EditAddTerminal')), 'Terminal-bundle')


export const ListRepresentantes = r => require.ensure([], () => r(require('../components/Representantes/ListRepresentantes')), 'Representante-bundle')
export const EditAddRepresentante = r => require.ensure([], () => r(require('../components/Representantes/EditAddRepresentante')), 'Representante-bundle')

export const ListApproveAccount = r => require.ensure([], () => r(require('../../ApproveAccount/components/ListApproveAccount')), 'Records-bundle')
export const ViewApproveAccount = r => require.ensure([], () => r(require('../../ApproveAccount/components/ViewApproveAccount')), 'Records-bundle')

export const ListRiskAnalysis = r => require.ensure([], () => r(require('../../RiskAnalysis/components/ListRiskAnalysis')), 'Records-bundle')
export const ViewRiskAnalysis = r => require.ensure([], () => r(require('../../RiskAnalysis/components/ViewRiskAnalysis')), 'Records-bundle')

export const ListGerenteMarketplaces = r => require.ensure([], () => r(require('../components/GerenteMarketplaces/ListGerenteMarketplaces')), 'GerenteMarketplaces-bundle')
export const EditAddGerenteMarketplace = r => require.ensure([], () => r(require('../components/GerenteMarketplaces/EditAddGerenteMarketplace')), 'GerenteMarketplaces-bundle')
export const ViewRiskAnalysisBeneficiary = r => require.ensure([], () => r(require('../../RiskAnalysis/components/ViewRiskAnalysisBeneficiary')), 'Records-bundle')
export const ViewRiskAnalysisDigital = r => require.ensure([], () => r(require('../../RiskAnalysis/components/ViewRiskAnalysisDigital')), 'Records-bundle')

const children = [
  // User
  {
    name: 'records.users.index',
    path: 'usuarios',
    component: ListUsers,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Usuários',
      titleMenu: 'Usuários',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Usuários',
          pathName: ''
        },
      ]
    }
  },
  {
    name: 'records.users.create',
    path: 'usuarios/adicionando',
    component: EditAddUser,
    meta: {
      requiresAuth: true,
      title: 'Adicionando novo usário',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Usuários',
          pathName: 'records.users.index'
        },
        {
          name: 'Adicionando novo usário',
          pathName: 'records.users.create'
        },
      ]
    }
  },
  {
    name: 'records.users.edit',
    path: 'usuarios/:id',
    component: EditAddUser,
    meta: {
      requiresAuth: true,
      title: 'Editando usário',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Usuários',
          pathName: 'records.users.index'
        },
        {
          name: 'Editando usário',
          pathName: 'records.users.edit'
        },
      ]
    }
  },

  // Plans
  {
    name: 'records.plan.index',
    path: 'listagem-de-planos',
    component: ListPlan,
    meta: {
      requiresAuth: true,
      title: 'Listagem de planos',
      titleMenu: 'Planos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de planos',
          pathName: 'records.plan.index'
        },
      ]
    }
  },
  {
    name: 'records.plan.create',
    path: 'criar-plano',
    component: FormPlan,
    meta: {
      title: 'Novo Plano',
      rule: 'public',
      requiresAuth: true,
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de planos',
          pathName: 'records.plan.index'
        },
        {
          name: 'Novo Plano',
          pathName: 'records.plan.create'
        },
      ]
    }
  },
  {
    name: 'records.plan.edit',
    path: 'editar-plano/:id',
    component: FormEditPlan,
    meta: {
      title: 'Editar Plano',
      rule: 'public',
      requiresAuth: true,
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de planos',
          pathName: 'records.plan.index'
        },
        {
          name: 'Editar Plano',
          pathName: 'records.plan.edit'
        },
      ]
    }
  },

  // Gerente Marketplaces
  // ListGerenteMarketplaces
  {
    name: 'records.gerentemarketplaces.index',
    path: 'gerente-marketplaces',
    component: ListGerenteMarketplaces,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Gerente Marketplaces',
      titleMenu: 'Gerente Marketplaces',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Gerente Marketplaces',
          pathName: ''
        },
      ]
    }
  },
  {
    name: 'records.gerentemarketplaces.create',
    path: 'gerente-marketplaces/adicionando',
    component: EditAddGerenteMarketplace,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Gerente Marketplace',
      titleMenu: 'Gerente Marketplaces',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Gerente Marketplaces',
          pathName: 'records.gerentemarketplaces.index'
        },
        {
          name: 'Adicionando Gerente Marketplace',
          pathName: 'records.gerentemarketplaces.create'
        },
      ]
    }
  },
  {
    name: 'records.gerentemarketplaces.edit',
    path: 'gerente-marketplaces/:id',
    component: EditAddGerenteMarketplace,
    meta: {
      requiresAuth: true,
      title: 'Editando Gerente Marketplace',
      titleMenu: 'Gerente Marketplaces',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Gerente Marketplaces',
          pathName: 'records.gerentemarketplaces.index'
        },
        {
          name: 'Editando Gerente Marketplace',
          pathName: 'records.gerentemarketplaces.edit'
        },
      ]
    }
  },

  // Marketplaces
  // ListMarketplaces
  {
    name: 'records.marketplaces.index',
    path: 'marketplaces',
    component: ListMarketplaces,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Marketplaces',
      titleMenu: 'Marketplaces',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Marketplaces',
          pathName: ''
        },
      ]
    }
  },
  {
    name: 'records.marketplaces.create',
    path: 'marketplaces/adicionando',
    component: EditAddMarketplace,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Marketplace',
      titleMenu: 'Marketplaces',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Marketplaces',
          pathName: 'records.marketplaces.index'
        },
        {
          name: 'Adicionando Marketplace',
          pathName: 'records.marketplaces.create'
        },
      ]
    }
  },
  {
    name: 'records.marketplaces.edit',
    path: 'marketplaces/:id',
    component: EditAddMarketplace,
    meta: {
      requiresAuth: true,
      title: 'Editando Marketplace',
      titleMenu: 'Marketplaces',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Marketplaces',
          pathName: 'records.marketplaces.index'
        },
        {
          name: 'Editando Marketplace',
          pathName: 'records.marketplaces.edit'
        },
      ]
    }
  },


  // Estabelecimento Comercial
  {
    name: 'records.departments.index',
    path: 'listagem-estabelecimento-comercial',
    component: ListEstaComercial,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Estabelecimento Comercial',
      titleMenu: 'Estabelecimento Comercial',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Estabelecimento Comercial',
          pathName: 'records.departments.index'
        },
      ]
    }
  },
  {
    name: 'records.departments.create',
    path: 'estabelecimento-comercial/adicionando',
    component: EditAddEstaComercial,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Estabelecimento Comercial',
      titleMenu: 'Estabelecimento Comercial',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Estabelecimento Comercial',
          pathName: 'records.departments.index'
        },
        {
          name: 'Adicionando Estabelecimento Comercial',
          pathName: 'records.departments.create'
        },
      ]
    }
  },
  {
    name: 'records.departments.edit',
    path: 'estabelecimento-comercial/:id',
    component: EditAddEstaComercial,
    meta: {
      requiresAuth: true,
      title: 'Editando Estabelecimento Comercial',
      titleMenu: 'Estabelecimento Comercial',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Estabelecimento Comercial',
          pathName: 'records.departments.index'
        },
        {
          name: 'Editando Estabelecimento Comercial',
          pathName: 'records.departments.edit'
        },
      ]
    }
  },

  //ListModelEquipamento
  {
    name: 'records.modelEquipment.index',
    path: 'listagem-modelo-equipamento',
    component: ListModelEquipamento,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Modelo de Equipamento',
      titleMenu: 'Modelo de Equipamento',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Modelo de Equipamento',
          pathName: 'records.modelEquipment.index'
        },
      ]
    }
  },
  {
    name: 'records.modelEquipment.create',
    path: 'modelo-equipamento/adicionando',
    component: EditAddModelEquipamento,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Modelo de Equipamento',
      titleMenu: 'Modelo de Equipamento',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Modelo de Equipamento',
          pathName: 'records.modelEquipment.index'
        },
        {
          name: 'Adicionando Modelo de Equipamento',
          pathName: 'records.modelEquipment.create'
        },
      ]
    }
  },
  {
    name: 'records.modelEquipment.edit',
    path: 'modelo-equipamento/:id',
    component: EditAddModelEquipamento,
    meta: {
      requiresAuth: true,
      title: 'Editando Modelo de Equipamento',
      titleMenu: 'Modelo de Equipamento',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Modelo de Equipamento',
          pathName: 'records.modelEquipment.index'
        },
        {
          name: 'Editando Modelo de Equipamento',
          pathName: 'records.modelEquipment.edit'
        },
      ]
    }
  },




  // Equipamentos
  {
    name: 'records.equipment.index',
    path: 'listagem-equipamentos',
    component: ListEquipamentos,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Equipamentos',
      titleMenu: ' Equipamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Equipamentos',
          pathName: 'records.equipment.index'
        },
      ]
    }
  },
  {
    name: 'records.equipment.create',
    path: 'equipamentos/adicionando',
    component: EditAddEquipamento,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Equipamentos',
      titleMenu: ' Equipamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Equipamentos',
          pathName: 'records.equipment.index'
        },
        {
          name: 'Adicionando Equipamentos',
          pathName: 'records.equipment.create'
        },
      ]
    }
  },
  {
    name: 'records.equipment.edit',
    path: 'equipamentos/:id',
    component: EditAddEquipamento,
    meta: {
      requiresAuth: true,
      title: 'Editando Equipamentos',
      titleMenu: ' Equipamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Equipamentos',
          pathName: 'records.equipment.index'
        },
        {
          name: 'Editando Equipamentos',
          pathName: 'records.equipment.edit'
        },
      ]
    }
  },

  //  Terminais
  {
    name: 'records.terminal.index',
    path: 'listagem-terminais',
    component: ListTerminais,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Terminais',
      titleMenu: ' Terminais',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Terminais',
          pathName: 'records.terminal.index'
        },
      ]
    }
  },
  {
    name: 'records.terminal.create',
    path: 'terminais/adicionando',
    component: EditAddTerminal,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Terminal',
      titleMenu: ' Terminais',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Terminais',
          pathName: 'records.terminal.index'
        },
        {
          name: 'Adicionando Terminal',
          pathName: 'records.terminal.create'
        },
      ]
    }
  },
  {
    name: 'records.terminal.edit',
    path: 'terminais/:id',
    component: EditAddTerminal,
    meta: {
      requiresAuth: true,
      title: 'Editando Terminal',
      titleMenu: ' Terminais',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Terminais',
          pathName: 'records.terminal.index'
        },
        {
          name: 'Editando Terminal',
          pathName: 'records.terminal.edit'
        },
      ]
    }
  },

  // Representantes
  {
    name: 'records.representante.index',
    path: 'listagem-representante',
    component: ListRepresentantes,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Representantes',
      titleMenu: ' Representantes',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Representantes',
          pathName: 'records.representante.index'
        },
      ]
    }
  },
  {
    name: 'records.representante.create',
    path: 'representantes/adicionando',
    component: EditAddRepresentante,
    meta: {
      requiresAuth: true,
      title: 'Adicionando Representantes',
      titleMenu: ' Representantes',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Representantes',
          pathName: 'records.representante.index'
        },
        {
          name: 'Adicionando Representante',
          pathName: 'records.representante.create'
        },
      ]
    }
  },
  {
    name: 'records.representante.edit',
    path: 'representantes/:id',
    component: EditAddRepresentante,
    meta: {
      requiresAuth: true,
      title: 'Editando Representante',
      titleMenu: ' Representantes',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Listagem de Representantes',
          pathName: 'records.representante.index'
        },
        {
          name: 'Editando Representante',
          pathName: 'records.representante.edit'
        },
      ]
    }
  },

//  ApproveAccount
  {
    name: 'records.approveAccount.index',
    path: 'aprovar-contas',
    component: ListApproveAccount,
    meta: {
      requiresAuth: true,
      title: 'Aprovar Contas',
      titleMenu: 'Aprovar Contas',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Aprovar Contas',
          pathName: 'records.approveAccount.index'
        },
      ]
    }
  },
  {
    name: 'records.approveAccount.view',
    path: 'aprovar-contas/:id',
    component: ViewApproveAccount,
    meta: {
      requiresAuth: true,
      title: 'Aprovar Contas',
      titleMenu: 'Aprovar Contas',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Aprovar Contas',
          pathName: 'records.approveAccount.index'
        },
        {
          name: 'Visualizando',
          pathName: 'records.approveAccount.view'
        },
      ]
    }
  },

//  RiskAnalysis
  {
    name: 'records.riskAnalysis.index',
    path: 'analise-risco',
    component: ListRiskAnalysis,
    meta: {
      requiresAuth: true,
      title: 'Análise de Risco',
      titleMenu: 'Análise de Risco',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Análise de Risco',
          pathName: 'records.riskAnalysis.index'
        },
      ]
    }
  },
  {
    name: 'records.riskAnalysis.view',
    path: 'analise-risco/:id',
    component: ViewRiskAnalysis,
    meta: {
      requiresAuth: true,
      title: 'Análise de Risco',
      titleMenu: 'Análise de Risco',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Análise de Risco',
          pathName: 'records.riskAnalysis.index'
        },
        {
          name: 'Visualizando',
          pathName: 'records.riskAnalysis.view'
        },
      ]
    }
  },
  {
    name: 'records.riskAnalysisBeneficiary.view',
    path: 'analise-risco-beneficiario/:id',
    component: ViewRiskAnalysisBeneficiary,
    meta: {
      requiresAuth: true,
      title: 'Análise de Risco do Beneficiario',
      titleMenu: 'Análise de Risco do Beneficiario',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Análise de Risco do Beneficiario',
          pathName: 'records.riskAnalysisBeneficiary.index'
        },
        {
          name: 'Visualizando',
          pathName: 'records.riskAnalysisBeneficiary.view'
        },
      ]
    }
  },
  {
    name: 'records.riskAnalysisDigital.view',
    path: 'analise-risco-digital/:id',
    component: ViewRiskAnalysisDigital,
    meta: {
      requiresAuth: true,
      title: 'Análise de Risco Pagamentos Digitais',
      titleMenu: 'Análise de Risco Pagamentos Digitais',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Análise de Risco',
          pathName: 'records.riskAnalysis.index'
        },
        {
          name: 'Visualizando Análise de Risco Digital',
          pathName: 'records.riskAnalysisDigital.view'
        },
      ]
    }
  },
]

export default [{
  name: 'records',
  children,
  path: '/cadastros',
  component: Main,
  redirect: { name: 'home.index' },
  meta: {
    requiresAuth: true,
  }
}]
